module.exports = __webpack_public_path__ + "img/month_8_icon.c52caeb6.png";